var map = {
	"./bg-clock.webp": "67ca",
	"./delete/bf.jpg": "f6fb",
	"./delete/bf_m.jpg": "fdab",
	"./delete/main-big.jpg": "35a4",
	"./delete/main0.jpg": "6ab7",
	"./delete/main1.jpg": "fbb3",
	"./delete/main2.jpg": "4a60",
	"./delete/main2.png": "5968",
	"./delete/main3.jpg": "6e75",
	"./delete/main4.jpg": "64f6",
	"./main.jpg": "8e57",
	"./main0.jpg": "7c4d",
	"./shape-bottom.svg": "08cb",
	"./shape-top.svg": "db0b"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "43c2";